<img
  [src]="albionImageService.getItemImageUrl(item().uniqueName, quality(), size())"
  [matTooltip]="hideTooltip() ? null : item().localizedName"
  [alt]="item().localizedName"
  [style.width.px]="size()"
  [style.height.px]="size()"
  [style.background]="imageLoaded ? 'none' : 'url(assets/img/genericItem.webp) center/cover no-repeat'"
  (load)="imageLoaded = true"
  (error)="imageLoaded = false"
  style="border-radius: 6px; display: block"
/>
